const Title = ({ children }) => {
    return <h1 className="
    text-4xl md:text-5xl lg:text-6xl font-bold mb-8 h-48 content-center bg-gray-950 text-white w-full
    ">{children}</h1>
}

export default Title;